import { combineReducers } from "@reduxjs/toolkit";
import userSlice from "./userSlice";
import taskSlice from "./taskSlice";
import settingsSlice from "./settingsSlice";
import postSlice from "./postSlice";
import reportSlice from "./reportSlice";
import leaveSlice from "./leaveSlice";
import chatSlice from "./chatSlice";
import caseSlice from "./caseSlice";
import modalSlice from "./modalSlice";
import deptSlice from "./deptSlice";
import termSlice from "./termSlice";
import resignSlice from "./resignSlice";
import payrollSlice from "./payrollSlice";
import attendanceSlice from "./attendanceSlice";
import appraisalSlice from "./appraisalSlice";
import holidaySlice from "./holidaySlice";
import locationSlice from "./locationSlice";

const rootReducer = combineReducers({
    user: userSlice,
    task: taskSlice,
    settings: settingsSlice,
    post: postSlice,
    report: reportSlice,
    leave: leaveSlice,
    chat: chatSlice,
    cases: caseSlice,
    modal: modalSlice,
    department: deptSlice,
    termination: termSlice,
    resignation: resignSlice,
    payroll: payrollSlice,
    attendance: attendanceSlice,
    appraisal: appraisalSlice,
    holiday: holidaySlice,
    location: locationSlice,
})

export default rootReducer